export * from './click.to.edit.component';
export * from './click.to.edit.view.directive';
export * from './click.to.edit.input.directive';

import {ClickToEdit} from './click.to.edit.component';
import {ClickToEditView} from './click.to.edit.view.directive';
import {ClickToEditInput} from './click.to.edit.input.directive';

export const CLICK_TO_EDIT_COMPONENTS = [
    ClickToEdit,
    ClickToEditView,
    ClickToEditInput
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/click-to-edit/index.ts